/** Keep in sync with Android DailyQuestTaskNavigation / NavigateMessage.Target. */
export const DAILY_QUEST_NAVIGATION_SPECIAL_ALIASES = [
    'DAILY_BONUS',
    'CLAIM_DAILY_BONUS',
    'VIDEO_REWARD',
    'WATCH_REWARDED_AD',
    'CLAIM_VIDEO_REWARD',
] as const;

export const DAILY_QUEST_NAVIGATION_TARGETS = [
    'MATCH_DETAILS',
    'USER_DETAILS',
    'FOREIGN_USER_DETAILS',
    'TEAM_DETAILS',
    'LEAGUES',
    'HOME',
    'MATCHES',
    'TOP_MATCHES',
    'ACHIEVEMENTS',
    'SETTINGS',
    'RANKINGS',
    'SCORES',
    'SCORE_LEAGUES',
    'SCORE_MATCHES',
    'LEAGUE_MATCHES',
    'BALANCE_HISTORY',
    'SUPPORT',
    'COMMENTS_MATCH',
    'PROMO_LIST',
    'BETS',
    'FAQ',
    'SHOP',
    'EVENTS',
    'MATCH_STATS',
    'GET_COINS',
    'MESSAGES',
    'PRIVATE_MESSAGING',
    'COMMENTS',
    'BATTLES',
    'SUPPORT_CHAT',
    'CASINO',
    'SEARCH',
    'SEARCH_MATCHES',
    'SEARCH_LEAGUES',
    'SEARCH_TEAMS',
    'DAILY_COMPETITIONS',
    'COMPETITION_DETAILS',
    'MINI_GAMES_HOME_ACTIVITY',
    'TVBET',
    'OFFERS',
    'TASKS',
    'VIP_TIPS',
    'FOLLOWERS',
    'DELETE_ACCOUNT',
    'DRAWER',
    'BATTLE_NEW',
    'FLASH_BET',
    'FLASH_BET_CATEGORIES',
    'FLASH_BET_MATCH_START',
    'FLASH_BET_GAME',
] as const;

export const DAILY_QUEST_NAVIGATION_ALLOWED: readonly string[] = [
    ...DAILY_QUEST_NAVIGATION_SPECIAL_ALIASES,
    ...DAILY_QUEST_NAVIGATION_TARGETS,
];

/** Common overrides shown first in the template editor dropdown. */
export const DAILY_QUEST_NAVIGATION_PRESETS = [
    'TOP_MATCHES',
    'BATTLES',
    'DAILY_COMPETITIONS',
    'FLASH_BET',
    'MINI_GAMES_HOME_ACTIVITY',
    'SHOP',
    'RANKINGS',
    'TVBET',
    'DAILY_BONUS',
    'VIDEO_REWARD',
] as const;

export const DAILY_QUEST_NAVIGATION_MORE = DAILY_QUEST_NAVIGATION_ALLOWED.filter(
    value => !DAILY_QUEST_NAVIGATION_PRESETS.includes(value as typeof DAILY_QUEST_NAVIGATION_PRESETS[number]),
).sort();
